import { LESSON_GROUPS } from "@/graphql/queries/lessons";
import { useLazyQuery } from "@apollo/client";
import { createContext, useContext, useState } from "react";

const GroupsContext = createContext(null);
const ActiveGroupContext = createContext(null);
const OpenGroupIdContext = createContext(null);

export function GroupsProvider({ children }) {
    const [groups, setGroups] = useState([]);
    const [userCurrentGroup, setUserCurrentGroup] = useState({});
    const [openGroupId, setOpenGroupId] = useState(null);

    return (
        <OpenGroupIdContext.Provider value={[openGroupId, setOpenGroupId]}>
            <GroupsContext.Provider value={[groups, setGroups]}>
                <ActiveGroupContext.Provider
                    value={[userCurrentGroup, setUserCurrentGroup]}
                >
                    {children}
                </ActiveGroupContext.Provider>
            </GroupsContext.Provider>
        </OpenGroupIdContext.Provider>
    );
}

export default function useGroups({ courseId } = {}) {
    courseId = parseInt(courseId);
    const [groups, setGroups] = useContext(GroupsContext);
    const [userCurrentGroup, setUserCurrentGroup] =
        useContext(ActiveGroupContext);
    const [openGroupId, setOpenGroupId] = useContext(OpenGroupIdContext);

    const [getGroups, { loading }] = useLazyQuery(LESSON_GROUPS);

    const _getGroups = () => {
        getGroups({
            variables: { courseId: courseId },
            onCompleted: (data) => {
                if (Array.isArray(data?.["lessonGroups"])) {
                    const lessonGroups = data["lessonGroups"];
                    setGroups(lessonGroups);
                    _setUserCurrentGroup(lessonGroups);
                }
            },
        });
    };

    const _setUserCurrentGroup = (lessonGroups) => {
        var coppiedGroups = lessonGroups.map((i) => i);
        coppiedGroups.sort((a, b) => (a.order < b.order ? -1 : 1));
        let currentLessonGroup = null;
        for (const lessonGroup of coppiedGroups) {
            if (!lessonGroup.isFinished) {
                currentLessonGroup = lessonGroup;
                break;
            }
        }
        if (!currentLessonGroup)
            currentLessonGroup = coppiedGroups[coppiedGroups.length];
        setUserCurrentGroup(currentLessonGroup);
    };

    const _getCurrentLessonGroup = (lessonNumber) => {
        return groups?.find((lessonGroup) => {
            const foundLesson =
                lessonGroup?.lessons?.find((lesson) => {
                    return String(lesson.lessonNumber) == String(lessonNumber);
                }) ?? null;

            return !!foundLesson;
        });
    };

    const _getGroupById = (groupId) => {
        return groups?.find(
            (group) => String(group.lessonGroupId) == String(groupId)
        );
    };

    const _getOpenGroup = () => {
        return _getGroupById(openGroupId);
    };

    const _getPrevGroup = () => {
        var coppiedGroups = groups.map((i) => i);
        coppiedGroups.sort((a, b) => (a.order < b.order ? -1 : 1));

        let prevGroup = null;
        for (let group of coppiedGroups) {
            if (String(group.lessonGroupId) == String(openGroupId)) {
                break;
            }
            prevGroup = group;
        }

        return prevGroup;
    };

    const _getNextGroup = () => {
        var coppiedGroups = groups.map((i) => i);
        coppiedGroups.sort((a, b) => (a.order < b.order ? -1 : 1));

        let nextGroup = null;
        for (let group of coppiedGroups) {
            nextGroup = group;
            if (String(group.lessonGroupId) == String(openGroupId)) {
                break;
            }
        }

        return nextGroup;
    };

    return {
        loading,
        openGroupId,
        setOpenGroupId,
        groups: groups,
        getGroups: _getGroups,
        getGroupById: _getGroupById,
        getOpenGroup: _getOpenGroup,
        userCurrentGroup: userCurrentGroup,
        getPrevGroup: _getPrevGroup,
        getNextGroup: _getNextGroup,
        getGroupOfCurrentLesson: _getCurrentLessonGroup,
    };
}
